window._ = require('lodash');
window.Swal = require('sweetalert2');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) { }

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import 'bootstrap-select';

window.navTabActivate = function (tabList, tabListContent, name) {
    const navLinks = $('#' + tabList + ' .nav-link');
    const navPanels = $('#' + tabListContent + ' .tab-pane');

    // Deaktiviere alle Tabs und Inhalte
    navLinks.removeClass('active');
    navPanels.removeClass('show active');

    // Wenn Auslöser ein Link Tag ist:
    let navlink = $('#' + tabList + ' .nav-link[href="#' + name + '"]');
    let navTargetId = null;

    if (navlink.length) {
        navTargetId = navlink.attr('href');
    } else {
        // Wenn Auslöser ein Button (bootstrap < 5) ist:
        navlink = $('#' + tabList + ' .nav-link[data-target="#' + name + '"]');
        if (navlink.length) 
            navTargetId = navlink.data('target');
        else  {
            navlink = $('#' + tabList + ' .nav-link[data-bs-target="#' + name + '"]');
            if (navlink.length) 
                navTargetId = navlink.attr('data-bs-target');
        }
    }

    if (navlink.length) {
        // Aktiviere den ausgewählten Tab und den entsprechenden Inhalt
        navlink.addClass('active');

        if (navTargetId.length) {
            let navTarget = $(navTargetId);
            if (navTarget.length)
                navTarget.addClass('show active');
        }
    }
};
